<adapt-dashboard-element *adaptIfAlto="false"
                         name="Meetings"
                         [url]="meetingsUrl$ | async">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
</adapt-dashboard-element>

<adapt-styled-dashboard-element *adaptIfAlto="true"
                                name="Meetings"
                                linkText="View all meetings"
                                [url]="meetingsUrl$ | async">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
</adapt-styled-dashboard-element>

<ng-template #content>
    <div class="d-flex flex-column gap-3">
        <ng-container *adaptLoadingUntilFirstEmit="let ongoingMeetings of ongoingMeetings$">
            @if (ongoingMeetings.length > 0) {
                <div class="dashboard-meetings">
                    <h4>In progress</h4>
                    @for (meeting of ongoingMeetings; track meeting) {
                        <adapt-meeting-dashboard-card [meeting]="meeting"
                                                      [showTeamName]="showTeamName"></adapt-meeting-dashboard-card>
                    }
                </div>
            }
        </ng-container>
        <div *adaptLoadingUntilFirstEmit="let upcomingMeetings of upcomingMeetings$"
             class="dashboard-meetings">
            @if (upcomingMeetings.length > 0) {
                <h4>
                    Upcoming
                    <span class="fal fa-info-circle small"
                          adaptTooltip="Shows the next two meetings scheduled in the next 2 weeks"></span>
                </h4>
                @for (meeting of upcomingMeetings; track meeting) {
                    <adapt-meeting-dashboard-card [meeting]="meeting"
                                                  [showTeamName]="showTeamName"></adapt-meeting-dashboard-card>
                }
            } @else {
                <h4>Upcoming</h4>
                There are no meetings scheduled in the next 2 weeks.
            }
        </div>
        <ng-container *adaptLoadingUntilFirstEmit="let recentMeetings of recentMeetings$">
            @if (recentMeetings.length > 0) {
                <div class="dashboard-meetings">
                    <h4>
                        Recent
                        <span class="fal fa-info-circle small"
                              adaptTooltip="Shows the two most recently held meetings in the last 2 weeks"></span>
                    </h4>
                    @for (meeting of recentMeetings; track meeting) {
                        <adapt-meeting-dashboard-card [meeting]="meeting"
                                                      [showTeamName]="showTeamName"></adapt-meeting-dashboard-card>
                    }
                </div>
            }
        </ng-container>
        @if (team$ | async; as team) {
            <button adaptButtonIcon="add"
                    class="btn btn-primary"
                    *adaptIfAuthorised="editTeamKanban; entity: team"
                    [adaptBlockingClick]="createNewTeamMeeting"
                    [adaptBlockingClickParam]="team">Schedule a meeting</button>
        }
    </div>
</ng-template>
